import * as React from "react";
import {Datagrid, FunctionField, TextField, TopToolbar} from "react-admin";
import CalendarEventActions from "./CalendarEventActions";
import CreateGradientButtonMod from "../../../Component/Layouts/Button/CreateGradientButtonMod";
import ListMod from "../../../Component/Redesign/ListMod";
import {convertedDateWithTimeGMT} from "../../../Functions/ConvertedDate";
import {CalendarEventImagePreview} from "./form";

const ListActions = ({className}) => (
    <TopToolbar className={className}>
        <div className="actionsWrap">
            <div className="addCategoryBtnWrap">
                <CreateGradientButtonMod label={'Add New Calendar Event'} />
            </div>
        </div>
    </TopToolbar>
);

export const CalendarEventsList = (props) => (
    <div className="customTableWrap pt-32">
        <ListMod
            {...props}
            title={'Calendar Events'}
            actions={<ListActions />}
            sort={{field: 'date', order: 'ASC'}}
        >
            <Datagrid bulkActionButtons={false}>
                <TextField label="Title" source="title" sortBy="title" />
                <FunctionField label="Date" source="date" render={(record) => (
                    record?.date ? convertedDateWithTimeGMT(record.date) : ''
                )}/>
                <FunctionField label="Image" sortable={false} render={(record) => (
                    <CalendarEventImagePreview record={record} />
                )}/>
                <FunctionField label="" source="actions" sortable={false} render={(record) => (
                    <CalendarEventActions id={record.id} record={record} />
                )}/>
            </Datagrid>
        </ListMod>
    </div>
);
